import { formatUnits } from "@ethersproject/units";
import { Promise } from "bluebird";

export const getTotalAndDebtForAccount = async (_loadHelper, marginPool, userBalances, underPriceBN, account, underlyingTokenAddress, baseAddress) => {
  console.log("Call blockchain - getTotalDebtInReferenceToken");
  console.log("Call blockchain - getAccountValueInReferenceToken");
  console.log("Call blockchain - getBorrowerDebtAmount");
  console.log("Call blockchain - getBorrowerDebtAmount");
  console.log("Call blockchain - balanceOf");
  console.log("Call blockchain - balanceOf");

  // OLD CODE
  let [totalDebt, netValue, borrowedDebtEthAmount, borrowedDebtBaseAmount, usdBalance, ethBalance] = await Promise.all([
    marginPool.methods.getTotalDebtInReferenceToken(account, underPriceBN).call(),
    userBalances.methods.getAccountValueInReferenceToken(account, underPriceBN).call(),
    marginPool.methods.getBorrowerDebtAmount(underlyingTokenAddress, account).call(),
    marginPool.methods.getBorrowerDebtAmount(baseAddress, account).call(),
    userBalances.methods.balanceOf(baseAddress, account).call(),
    userBalances.methods.balanceOf(underlyingTokenAddress, account).call()
  ]);

  totalDebt = parseFloat(formatUnits(totalDebt, 18));
  netValue = parseFloat(formatUnits(netValue, 18));
  borrowedDebtEthAmount = parseFloat(formatUnits(borrowedDebtEthAmount, 18));
  borrowedDebtBaseAmount = parseFloat(formatUnits(borrowedDebtBaseAmount, 18));
  usdBalance = parseFloat(formatUnits(usdBalance, 18));
  ethBalance = parseFloat(formatUnits(ethBalance, 18));

  return { account, debt: totalDebt, total: netValue, borrowedDebtEthAmount, borrowedDebtBaseAmount, usdBalance, ethBalance };

  // // NEW CODE
  // console.log("Call blockchain - loadMarginAccountData")
  // const result = await loadHelper.methods.loadMarginAccountData(marginPool._address, userBalances._address, account, underPriceBN).call();

  // let collateralTokens = result.collateralTokens;
  // collateralTokens = await Promise.map(collateralTokens, async (token, i) => {
  //   let price;
  //   let symbol;
  //   if (token.collateralToken.toString() === baseAddress) {
  //     price = 10 ** 18;
  //     symbol = "USD";
  //   } else {
  //     price = underPriceBN;
  //     symbol = "ETH";
  //   }
  //   return {
  //     symbol,
  //     assetAddress: token.collateralToken,
  //     borrowedAmount: token.borrowedAmount,
  //     lendProceeds: token.lendProceeds,
  //     price
  //   };
  // });

  // const totalDebt = parseFloat(formatUnits(result.totalDebt, 18));
  // const totalLiq = parseFloat(formatUnits(result.totalLiquidity, 18));

  // // const marginAccountData = {
  // //   collateralTokens,
  // //   health: result.health,
  // //   isLiquidatable: result.isLiquidatable,
  // //   liquidationThreshold: result.liquidationThreshold,
  // //   recoveryThreshold: result.recoveryThreshold,
  // //   totalLiquidity: result.totalLiquidity,
  // //   totalDebt: result.totalDebt
  // // };

  // return {
  //   account,
  //   debt: totalDebt,
  //   total: totalLiq,
  //   borrowedDebtEthAmount,
  //   borrowedDebtBaseAmount
  // };
};

export const getPositionData = async (market, tokenId, underPriceBN) => {
  console.log("Call blockchain - getPositionHealth");
  console.log("Call blockchain - positions");
  let [healthBN, position] = await Promise.all([market.methods.getPositionHealth(tokenId, underPriceBN).call(), market.methods.positions(tokenId).call()]);
  let health = parseFloat(formatUnits(healthBN.toString(), 18));
  const lower = parseInt(position.lower);
  const upper = parseInt(position.upper);
  //console.log(position);

  return { health, lower, upper };
};
